/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderManagerRoutingModule } from './builder-manager-routing.module';
import { CashFlowForecastDetailsComponent } from './cash-flow-forecast/components/cash-flow-forecast-details/cash-flow-forecast-details.component';
import { CashFlowForecastDetailsBusinessService } from './cash-flow-forecast/resources/cash-flow-forecast-details-business.service';
import { EomReportBusinessService, EomReportDetailsComponent } from './eom-reports';
import { FranchiseReportFilterComponent } from './franchise-monthly-report/components/franchise-report-filter/franchise-report-filter.component';

import { FranchiseMonthlyReportBusinessService } from './franchise-monthly-report/resources/franchise-monthly-report-business.service';
import { JobRedoEstimateComponent } from './job-redo/components/job-redo-estimate/job-redo-estimate.component';
import { JobRedoBusinessService } from './job-redo/resources/job-redo-business.service';
import { WipDetailsComponent } from './wip/components/wip-details/wip-details.component';
import { WipJobListComponent } from './wip/components/wip-job-list/wip-job-list.component';
import { WipJournalLogComponent } from './wip/components/wip-journal-log/wip-journal-log.component';
import { WipJournalsDialogComponent } from './wip/components/wip-journals-dialog/wip-journals-dialog.component';
import { WipMasterInfoComponent } from './wip/components/wip-master-info/wip-master-info.component';
import { WipBusinessService } from './wip/resources/wip-business.service';
import { CareerEnquiriesBusinessService } from './career-enquiries/resource/career-enquiries-business.service';
import { CareerEnquiriesListComponent } from './career-enquiries/components/career-enquiries-list/career-enquiries-list.component';
import { CareerEnquiriesDetailsComponent } from './career-enquiries/components/career-enquiries-details/career-enquiries-details.component';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),

    BuilderManagerRoutingModule,
  ],
  providers: [
    JobRedoBusinessService,
    CashFlowForecastDetailsBusinessService,
    WipBusinessService,
    FranchiseMonthlyReportBusinessService,
    EomReportBusinessService,
    CareerEnquiriesBusinessService,
  ],
  declarations: [
    JobRedoEstimateComponent,
    CashFlowForecastDetailsComponent,
    WipDetailsComponent,
    WipMasterInfoComponent,
    WipJobListComponent,
    WipJournalLogComponent,
    WipJournalsDialogComponent,
    FranchiseReportFilterComponent,
    EomReportDetailsComponent,
    CareerEnquiriesListComponent,
    CareerEnquiriesDetailsComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})

export class BuilderManagerModule {
}
